'use strict'

const u = require('universalify').fromCallback
module.exports = {
  copy: u(require('./copy'))
}



//////////////////
// WEBPACK FOOTER
// ./~/fs-extra/lib/copy/index.js
// module id = 1293
// module chunks = 0 1